<template>
    <v-dialog v-model="shows" width="960">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card v-bind="{ loading }">
            <v-card-title class="subtitle-1" primary-title>
                CP별 API 가격 및 사용 여부 설정
                <v-spacer />
                <v-btn absolute right text icon @click="shows = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <giftcard-cp-price-dialog-info v-bind="{ value: giftcard }" />
                <v-card-subtitle>CP 등록</v-card-subtitle>
                <v-divider></v-divider>
                <giftcard-cp-price-dialog-filter v-bind="{ value: forms, selected }" @input="update" />
                <v-data-table v-model="selected" show-select :loading="loading" :headers="headers" :items="forms" item-key="cp._id" disable-sort>
                    <template v-slot:item.cp="{ item }">
                        {{ item.cp.name }}
                    </template>
                    <template v-slot:item.discountRate="{ item }">
                        <v-text-field v-model="item.discountRate" outlined dense hide-details="auto" type="number" />
                    </template>
                    <template v-slot:item.price="{ item }">
                        {{ Math.round(giftcard.faceamt * (1 - item.discountRate / 100)) }}
                    </template>
                    <template v-slot:item.isApi="{ item }">
                        <v-switch v-model="item.isApi" />
                    </template>
                    <!-- <template v-slot:item.actions="{ item, index }"> -->
                    <template v-slot:item.actions="{ item }">
                        <!-- <v-btn color="red" icon @click="remove(index)"><v-icon>mdi-minus</v-icon></v-btn> -->
                        <v-btn color="red" icon @click="remove(item)"><v-icon>mdi-minus</v-icon></v-btn>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" dark text @click="() => (shows = false)">취소</v-btn>
                <v-btn color="primary" dark @click="save">저장</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import GiftcardCpPriceDialogInfo from "./giftcard-cp-price-dialog-info.vue";
import GiftcardCpPriceDialogFilter from "./giftcard-cp-price-dialog-filter.vue";
export const initGiftcardCpPrice = (form = {}) => ({
    ...form,
    _cp: form?._cp || null,
    cp: form?.cp || null,
    discountRate: form?.discountRate || 0,
    price: form?.price || 0,
    isApi: form?.isApi || false,
});
export default {
    components: {
        GiftcardCpPriceDialogInfo,
        GiftcardCpPriceDialogFilter,
    },
    props: {
        _giftcard: { type: String, default: "" },
    },
    data() {
        return {
            shows: false,
            loading: false,
            headers: [
                // { text: "no", align: "center", width: 40, value: "no" },
                { text: "CP", align: "center", width: 140, value: "cp" },
                { text: "API 할인율(%)", align: "center", width: 80, value: "discountRate" },
                { text: "API 가격", align: "center", width: 50, value: "price" },
                { text: "API 여부", align: "left", width: 20, value: "isApi" },
                { text: "Actions", width: 100, align: "left", value: "actions" },
            ],
            selected: [],
            giftcard: {},
            forms: [],
        };
    },
    methods: {
        init() {
            this.search();
            // this.sync();
        },
        async search() {
            try {
                let { giftcard } = await api.console.shop.giftcards.get({ _id: this._giftcard });
                this.giftcard = giftcard;
                this.sync();
            } catch (error) {
                console.error(error);
            }
        },
        async save() {
            try {
                // price = giftcard.faceamt 에서 dsicountRate 할인한 값
                this.forms.forEach((form, index) => {
                    if (form.discountRate === "") throw new Error("할인율을 포함시켜주세요. (기본값: 0)");
                    this.forms[index].price = Math.round(this.giftcard.faceamt * (1 - form.discountRate / 100));
                });
                this.giftcard.cpamtOptions = this.forms;

                await api.console.shop.giftcards.put(this.giftcard);

                alert("저장되었습니다.");
                this.shows = false;
            } catch (error) {
                console.error(error);
                alert(error.message);
            }
        },
        sync() {
            this.forms = this.giftcard?.cpamtOptions?.map(initGiftcardCpPrice);
        },
        update(forms) {
            this.forms = forms;
        },
        remove(item) {
            const index = this.forms.findIndex(({ _cp }) => _cp === item._cp);
            this.forms.splice(index, 1);
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        shows() {
            this.init();
            if (!this.shows) this.$emit("update");
        },
    },
};
</script>

<style>
</style>